// extracted by mini-css-extract-plugin
export var content = "hundarna-module--content--3MuJo";
export var sectionTitle = "hundarna-module--sectionTitle--_VGBA";
export var dogTray = "hundarna-module--dogTray--3v4Mh";
export var info = "hundarna-module--info--3VY5L";
export var left = "hundarna-module--left--3hWub";
export var right = "hundarna-module--right--TEsdo";
export var chartImageWrapper = "hundarna-module--chartImageWrapper--32wd9";
export var dogTrayInfo = "hundarna-module--dogTrayInfo--3glbN";